import { Supplies } from '@factorin/domain';

import { withUrl, patch, list } from '../rest';


type PatchDiscountSupplies = {
    uids: Supplies.DiscountDraftSupply['Uid'][];
    confirm: boolean;
}

const discountSuppliesPart = withUrl('discountsupplies');
export const discountSupplies = {
    ...list<Supplies.DiscountSupply>(discountSuppliesPart()),
    confirm: patch<PatchDiscountSupplies, void>(
        ({ uids, confirm }) => discountSuppliesPart({
            body: {
                Confirm: confirm,
                Uids: uids,
            },
        }),
    ),
};
